(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["portfolio-gallery-template"] && !window.DesignMode) return;
  try {
    
  $(()=>{
    $("#portfolio-gallery").unitegallery({
      lightbox_type: "compact",
      lightbox_overlay_opacity: 0.75,
      lightbox_slider_image_border_width: 4,			
      lightbox_slider_image_border_color: "#ffffff",	
      lightbox_slider_image_border_radius: 4.5,
    });
  });

  } catch(e) { console.error(e); }
})();
})();
